<template>
  <div>
    <div v-if="ready && svg !== false" id="customer-svg">
      <span v-if="svg !== false" v-html="svg"></span>
    </div>
    <v-overlay :model-value="true" v-else class="align-center justify-center">
      <v-progress-circular v-if="svg !== false" :size="50" color="primary" indeterminate></v-progress-circular>
      <div v-else>Visual does not exist for this shipment</div>
    </v-overlay>
  </div>
</template>

<script>
import paper from 'paper'
import { db } from '@/js/db'
import { doc, getDoc } from 'firebase/firestore'

export default {
  name: 'CustomerSVG',
  props: ['quoteID', 'versionID'],
  data() {
    return {
      quote: null,
      version: null,
      svg: null,
      margins: 0,
      ready: false
    }
  },
  created() {
    this.$live('quote', doc(db, 'quotes', this.quoteID)).then(async () => {
      this.version = this.quote?.versions?.find((v) => this.versionID == v.id) ?? null

      // All three dead ends collapse to the one state: there is no visual to draw. The template
      // already renders "Visual does not exist for this shipment" off `svg === false`.
      //
      // `customerVisualID` has to be checked BEFORE the ref is built rather than left to
      // `visualSnap.exists()`: `doc()` with an undefined id throws out of `ResourcePath.fromString`,
      // which calls `indexOf` on it. So execution never reached the `exists()` branch and the view
      // threw instead. A version only gains that id once a CAD has been saved for it
      // (CustomerCad.vue:1173), and every other caller guards it the same way (CustomerCad.vue:313
      // before :321) — this was the one that did not, while Shipments' visual icon opens the route
      // for any shipment.
      if (!this.version || !this.version.customerVisualID) {
        this.svg = false
        this.ready = true
        return
      }

      const visualSnap = await getDoc(doc(db, 'visuals', this.version.customerVisualID))

      this.ready = true

      if (visualSnap.exists()) {
        var p = new paper.Project()
        p.importJSON(visualSnap.data().json)

        // Show all grain icons
        p.activeLayer.children.forEach((item) => {
          const grainIcon = item.children?.grain
          if (grainIcon) {
            grainIcon.style.fillColor = 'black'
          }
        })

        p.activeLayer.fitBounds(
          new paper.Rectangle(
            new paper.Point(this.margins, this.margins * 2),
            new paper.Size(1024 - this.margins * 2, 710 - this.margins * 2)
          )
        )

        this.svg = p.exportSVG({
          asString: true,
          bounds: new paper.Rectangle(new paper.Point(0, 0), new paper.Size(1024, 710))
        })
      } else {
        this.svg = false
      }
    })
  }
}
</script>

<style lang="scss">
#customer-svg {
  .details {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
